import React from 'react';
import ReactDOM from 'react-dom/client';
import toast from 'react-hot-toast';
import './index.css';
import App from './App';
import { register as registerServiceWorker, applyUpdate } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Installable app + instant loads. When a new build is waiting, offer a
// reload instead of silently running the old one until every tab is closed.
registerServiceWorker({
  onUpdate: (registration) => {
    toast((t) => (
      <span className="text-sm">
        A new version of Expressway is ready.{' '}
        <button onClick={() => { toast.dismiss(t.id); applyUpdate(registration); }}
          className="ml-2 font-semibold text-orange-600 underline">Reload now</button>
      </span>
    ), { duration: Infinity, id: 'sw-update' });
  },
});
